<div class="content-body default-height">
    <!-- Breadcrumb  -->
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="'Back'" (addEvent)="viewPropertyEvent($event)">
    </app-breadcrumb>
    <div class="container-fluid">
        <div class="card profile-overview profile-overview-wide">
            <div class="card-body d-flex  pb-1">
                <div class="clearfix">
                    <div class="d-inline-block position-relative me-sm-4 me-3 mb-1 mb-lg-0">
                        <label for="upload" class="c-pointer">
                            <img [src]="selectedProperty?.cover_image" alt="" class="rounded-4 profile-avatar"
                                appDefaultImage>
                            <p class="glyphicon glyphicon-folder-open" aria-hidden="true">Update cover photo<i
                                    class="fa fa-edit ms-1"></i></p>
                            <input type="file" id="upload" accept="image/*" class="display"
                                (input)="updateCoverPhoto($event)">
                        </label>

                    </div>
                </div>
                <div class="clearfix d-xl-flex flex-grow-1">
                    <div class="mt-1 d-flex ">
                        <div class="ms-5" *ngIf="selectedProperty?.property_manager">
                            <h4 class="badge badge-md badge-success light border-0">Property Manager</h4>
                            <div class="las la-user p-1 btn-block"> {{ selectedProperty.property_manager.first_name }}
                                {{ selectedProperty.property_manager?.last_name }} </div>
                            <div class="las la-envelope p-1 btn-block"> {{ selectedProperty.property_manager.email }}
                            </div>
                            <div class="las la-phone p-1 btn-block"> {{ selectedProperty.property_manager.phone }}
                            </div>
                        </div>
                        <div class="ms-5" *ngIf="selectedProperty?.owner">
                            <h4 class="badge badge-md badge-success light border-0">Owner</h4>
                            <div class="las la-user p-1 btn-block"> {{ selectedProperty.owner.first_name }} {{
                                selectedProperty.owner.last_name }} </div>
                            <div class="las la-envelope p-1 btn-block"> {{ selectedProperty.owner.email }} </div>
                            <div class="las la-phone p-1 btn-block"> {{ selectedProperty.owner.phone }} </div>
                        </div>
                        <div class="ms-5" *ngIf="selectedProperty?.tenant">
                            <h4 class="badge badge-md badge-success light border-0">Tenant</h4>
                            <div class="las la-user p-1 btn-block"> {{ selectedProperty.tenant.first_name }} {{
                                selectedProperty.tenant.last_name }} </div>
                            <div class="las la-envelope p-1 btn-block"> {{ selectedProperty.tenant.email }} </div>
                            <div class="las la-phone p-1 btn-block"> {{ selectedProperty.tenant.phone }} </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="ms-3">
                <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs tabs-display">
                    <li [ngbNavItem]="1">
                        <a ngbNavLink>Property</a>
                        <ng-template ngbNavContent>
                            <form *ngIf="propertyForm" [formGroup]="propertyForm" (ngSubmit)="saveProperty()"
                                autocomplete="off">
                                <div class="p-3">
                                    <div class="row mt-2 ms-2">

                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Property
                                                Name<span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="Villa1" formControlName="name">
                                            <div *ngIf="propertyForm?.get('property_name')?.invalid && propertyForm?.get('property_name')?.touched"
                                                class="required">
                                                Property Name is required
                                            </div>
                                        </div>
                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">Property
                                                Type<span class="text-danger">*</span></label>
                                            <select class="form-select" formControlName="type">
                                                <option data-display="Select" value="" selected>Please select</option>
                                                <option value="House/Villa">House/Villa</option>
                                                <option value="Commercial Property">Commercial Property</option>
                                                <option value="Office">Office</option>
                                                <option value="Retail">Retail</option>
                                                <option value="Storage">Storage</option>
                                                <option value="Hospitality">Hospitality</option>
                                                <option value="Apartment">Apartment</option>
                                                <option value="Studio">Studio</option>
                                                <option value="Showroom">Showroom</option>
                                                <option value="Warehouses">Warehouses</option>
                                                <option value="Plot &amp; Farmhouse">Plot &amp; Farmhouse</option>
                                                <option value="multiUnit">Builder Multi Unit</option>
                                                <option value="pg">Paying Guest</option>
                                            </select>
                                            <div *ngIf="propertyForm?.get('property_type')?.invalid && propertyForm?.get('property_type')?.touched"
                                                class="required">
                                                Property Type is required
                                            </div>
                                        </div>

                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Address
                                                Line1<span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="" formControlName="address_1">
                                            <div *ngIf="propertyForm?.get('address_line1')?.invalid && propertyForm?.get('address_line1')?.touched"
                                                class="required">
                                                Address Line1 is required
                                            </div>
                                        </div>
                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">Address
                                                Line2</label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="HYD" formControlName="address_2">
                                        </div>
                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">Country<span
                                                    class="text-danger">*</span></label>
                                            <select2 ngDefaultControl [data]="countries" [templates]="template"
                                                class="select2" placeholder="Select country" formControlName="country"
                                                (update)="getStates()">
                                                <ng-template #template let-data="data">{{data?.name}}</ng-template>
                                            </select2>
                                            <div *ngIf="propertyForm?.get('country')?.invalid && propertyForm?.get('country')?.touched"
                                                class="required">
                                                Country is required
                                            </div>
                                        </div>
                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">State<span
                                                    class="text-danger">*</span></label>
                                            <select2 ngDefaultControl [data]="states" [templates]="template"
                                                class="select2" value="" placeholder="Select state"
                                                formControlName="state" (update)="getCities()">
                                                <ng-template #template let-data="data">{{data?.name}}</ng-template>
                                            </select2>
                                            <div *ngIf="propertyForm?.get('state')?.invalid && propertyForm?.get('state')?.touched"
                                                class="required">
                                                State is required
                                            </div>
                                        </div>
                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">City<span
                                                    class="text-danger">*</span></label>
                                            <select2 ngDefaultControl [data]="cities" [templates]="template"
                                                class="select2" value="" placeholder="Select city"
                                                formControlName="city">
                                                <ng-template #template let-data="data">{{data?.name}}</ng-template>
                                            </select2>
                                            <div *ngIf="propertyForm?.get('city')?.invalid && propertyForm?.get('city')?.touched"
                                                class="required">
                                                City is required
                                            </div>
                                        </div>
                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Locality<span
                                                    class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="" formControlName="locality">
                                            <div *ngIf="propertyForm?.get('locality')?.invalid && propertyForm?.get('locality')?.touched"
                                                class="required">
                                                Locality is required
                                            </div>
                                        </div>
                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Pincode<span
                                                    class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="" formControlName="postal_code">
                                            <div *ngIf="propertyForm?.get('postal_code')?.invalid && propertyForm?.get('postal_code')?.touched"
                                                class="required">
                                                Pincode is required
                                            </div>
                                        </div>
                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">Listing
                                                Status<span class="text-danger">*</span></label>
                                            <select class="form-select" formControlName="listing_status">
                                                <option value="" selected disabled>Please select</option>
                                                <option value="Sell">Sell</option>
                                                <option value="Sold">Sold</option>
                                                <option value="Rent Available">Rent Available</option>
                                                <option value="Rent Occupied">Rent Occupied</option>
                                                <option value="Property Management">Property Management</option>
                                                <option value="Tenant Placement">Tenant Placement</option>
                                                <option value="Plot Monitoring">Plot Monitoring</option>
                                                <option value="Repairs &amp; Renovation">Repairs &amp; Renovation</option>
                                                <option value="Documentation">Documentation</option>
                                            </select>
                                            <div *ngIf="propertyForm?.get('listing_status')?.invalid && propertyForm?.get('listing_status')?.touched"
                                                class="required">
                                                Listing Status is required
                                            </div>
                                        </div>

                                        <div class="col-xl-4 mb-3" *ngIf="displayStatus">
                                            <label for="exampleFormControlInput1-2" class="form-label">Status<span
                                                    class="text-danger">*</span></label>
                                            <select class="form-select" formControlName="status">
                                                <option disabled value="" selected>Please select</option>
                                                <option value="Archived">Archived</option>
                                                <option value="Work in Progress">Work In Progress</option>
                                                <option value="Enquiry">Enquiry</option>
                                                <option value="Approved">Approved</option>
                                                <option value="Pending">Pending</option>
                                            </select>
                                            <div *ngIf="propertyForm?.get('status')?.invalid && propertyForm?.get('status')?.touched"
                                                class="required">
                                                status is required
                                            </div>
                                        </div>

                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">Inspection<span
                                                    class="text-danger">*</span></label>
                                            <select class="form-select" formControlName="inspection_required">
                                                <option disabled value="" selected>Please select</option>
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                                <!-- <option value="Work in Progress">Work In Progress</option> -->
                                            </select>
                                            <div *ngIf="propertyForm?.get('inspection_required')?.invalid && propertyForm?.get('inspection_required')?.touched"
                                                class="required">
                                                Inspection is required
                                            </div>
                                        </div>
                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Contact Person
                                                Name</label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="John" formControlName="contact_person">
                                        </div>
                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Contact Person
                                                Phone</label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="12345678" formControlName="contact_person_phone">
                                        </div>

                                        <!-- <div class="col-xl-4 mb-3">
                                    <label for="exampleFormControlInput1-2" class="form-label">
                                        Brokerage
                                    </label>                         -->
                                        <!-- <div class="d-flex gap-2">
                                        <div class="col-xl-2 w-50"> -->
                                        <!-- <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="0" formControlName="brokerage">  -->
                                        <!-- </div> -->
                                        <!-- <div class="col-xl-2 w-50">
                                            <select class="form-select" formControlName="brokerage_value">
                                                <option data-display="Select" value="" selected disabled>Please select</option>
                                                <option value="K">K</option>
                                                <option value="CR">CR</option>
                                                <option value="Lacs">Lacs</option>
                                            </select>
                                        </div>    -->
                                        <!-- </div>                         -->
                                        <!-- </div> -->

                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">
                                                Security Deposit
                                            </label>
                                            <!-- <div class="d-flex gap-2">
                                        <div class="col-xl-2 w-50"> -->
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="0" formControlName="security_deposit">
                                            <!-- </div> -->
                                            <!-- <div class="col-xl-2 w-50">
                                            <select class="form-select" formControlName="security_deposot_value">
                                                <option data-display="Select" value="" selected disabled>Please select</option>
                                                <option value="K">K</option>
                                                <option value="CR">CR</option>
                                                <option value="Lacs">Lacs</option>
                                            </select>
                                        </div>    -->
                                            <!-- </div>                         -->
                                        </div>

                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Monthly
                                                Maintenance</label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="0" formControlName="monthly_maintenance">
                                        </div>

                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Owner Aggrement
                                                Start Date</label>
                                            <input type="date" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="" formControlName="owner_agreement_start">
                                        </div>

                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Owner Aggrement
                                                End Date</label>
                                            <input type="date" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="" formControlName="owner_agreement_end">
                                        </div>

                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Take Over
                                                Date</label>
                                            <input type="date" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="" formControlName="take_over_date">
                                        </div>

                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">
                                                <span
                                                    *ngIf="propertyForm.get('listing_status')?.value === 'Sold' || propertyForm.get('listing_status')?.value === 'Sell'">Amount</span>
                                                <span
                                                    *ngIf="propertyForm.get('listing_status')?.value != 'Sold' && propertyForm.get('listing_status')?.value != 'Sell'">Monthly Rent</span>
                                            </label>
                                            <!-- <div class="d-flex gap-2">
                                        <div class="col-xl-2 w-50"> -->
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="0" formControlName="monthly_rent">
                                            <!-- </div> -->
                                            <!-- <div class="col-xl-2 w-50">
                                            <select class="form-select" formControlName="monthly_rent_value">
                                                <option data-display="Select" value="" selected disabled>Please select</option>
                                                <option value="K">K</option>
                                                <option value="CR">CR</option>
                                                <option value="Lacs">Lacs</option>
                                            </select>
                                        </div>    -->
                                            <!-- </div>                         -->
                                        </div>

                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Notes</label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="notes" formControlName="notes">
                                        </div>

                                        <div class="col-xl-6 mb-3" *ngIf="displayPropertyManagers">
                                            <label for="exampleFormControlInput1-2" class="form-label">Select Property
                                                Managers</label>
                                            <ng-select [items]="allPropertyManagers" bindValue="uid"
                                                bindLabel="fullName" formControlName="property_managers"
                                                [multiple]="true" [searchable]="true"
                                                placeholder="search for property managers"
                                                [dropdownPosition]="'bottom'">
                                            </ng-select>
                                            <!-- <div *ngIf="propertyForm?.get('property_managers')?.invalid && propertyForm?.get('property_managers')?.touched" class="required">
                                        Select atleast one property manager
                                    </div> -->
                                        </div>

                                        <div class="col-xl-6 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">Select
                                                Owner</label>
                                            <ng-select [items]="allOwners" bindValue="uid" bindLabel="fullName"
                                                formControlName="owner_id" [multiple]="false" [searchable]="true"
                                                placeholder="search for owner" [dropdownPosition]="'bottom'"
                                                [typeahead]="searchInput$" [virtualScroll]="true"
                                                (scrollToEnd)="onScrollToEnd()">
                                            </ng-select>
                                            <!-- <div *ngIf="propertyForm?.get('property_managers')?.invalid && propertyForm?.get('property_managers')?.touched" class="required">
                                        Select atleast one property manager
                                    </div> -->
                                        </div>

                                        <div class="col-xl-6 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Video URL</label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="Video Url" formControlName="video_url">
                                        </div>

                                        <div class="col-xl-6 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">Property
                                                Visible</label>
                                            <select class="form-select" formControlName="property_visible">
                                                <option disabled value='' selected>Please select</option>
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </select>
                                        </div>

                                        <div class="col-xl-12 mb-3">
                                            <label class="form-label d-block">Property Category</label>
                                            <div class="d-flex flex-wrap gap-3">
                                                <div class="form-check" *ngFor="let cat of propertyCategoryOptions">
                                                    <input type="checkbox" class="form-check-input"
                                                        [id]="'property-category-' + cat.key"
                                                        [formControlName]="cat.key">
                                                    <label class="form-check-label" [for]="'property-category-' + cat.key">{{ cat.label }}</label>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="row">
                                        <div class="col-xl-12">
                                            <button class="btn btn-primary ms-1 me-3 float-end" type="submit"
                                                [disabled]="propertyForm.invalid || loadingService.isLoading()">Save
                                                Property</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="2">
                        <a ngbNavLink>Property Details</a>
                        <ng-template ngbNavContent>
                            <form [formGroup]="propertyDetailsForm" (ngSubmit)="savePropertyDetails()"
                                autocomplete="off">
                                <div class="p-3 mt-2 ms-2">

                                    <div class="row mt-2 ms-2">
                                        <!-- <div class="col-xl-4 mb-3">
                                                                                               <label for="exampleFormControlInput1-1" class="form-label">Project Name<span class="text-danger">*</span></label>
                                                                                               <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="Villa1" formControlName="project_name">
                                                                                               <div *ngIf="propertyForm?.get('project_name')?.invalid && propertyForm?.get('project_name')?.touched" class="required">
                                                                                                 Project Name is required
                                                                                             </div>
                                                                                           </div> -->
                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Floor</label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="3" formControlName="floor">
                                        </div>
                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Build Up
                                                Area</label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="2000" formControlName="built_up_area">
                                        </div>
                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Carpet
                                                Area</label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="1900" formControlName="carpet_area">
                                        </div>
                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">
                                                Flooring Type
                                            </label>
                                            <select class="form-select" formControlName="flooring_type">
                                                <option value="" selected disabled>Please select
                                                </option>
                                                <option value="marble">Marble</option>
                                                <option value="concrete">Concrete</option>
                                                <option value="granite">Granite</option>
                                                <option value="granite">Ceramic</option>
                                                <option value="granite">Cork</option>
                                                <option value="granite">Tile</option>
                                                <option value="granite">Stone flooring</option>
                                            </select>
                                        </div>
                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Facing</label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="East" formControlName="facing">
                                        </div>
                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Number of
                                                Parking</label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="2" formControlName="number_of_parkings">
                                        </div>
                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Parking
                                                Number</label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="1" formControlName="parking_number">
                                        </div>
                                        <div class="col-xl-4 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">
                                                Alloted Parking
                                            </label>
                                            <select class="form-select" formControlName="parking_type">
                                                <option data-display="Select" value="" selected>
                                                    Please select</option>
                                                <option value="covered_parking">Covered Parking
                                                </option>
                                                <option value="open_parking">Open Parking</option>
                                                <option value="none">None</option>
                                            </select>
                                        </div>
                                        <div class="col-xl-12 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">
                                                Willing to rent to(while rent option selected)
                                            </label>
                                            <div class="d-flex gap-2">
                                                <div class="col-xl-2">
                                                    <input type="checkbox" class="form-check-input"
                                                        id="exampleFormControlInput1-1" placeholder=""
                                                        formControlName="willing_to_rent_to_family">
                                                    <label for="exampleFormControlInput1-2"
                                                        class="form-label m-1 ps-1">Family</label>
                                                </div>
                                                <div class="col-xl-2">
                                                    <input type="checkbox" class="form-check-input"
                                                        id="exampleFormControlInput1-1" placeholder=""
                                                        formControlName="willing_to_rent_to_single_men">
                                                    <label for="exampleFormControlInput1-2"
                                                        class="form-label m-1 ps-1">Single
                                                        Men</label>
                                                </div>
                                                <div class="col-xl-2">
                                                    <input type="checkbox" class="form-check-input"
                                                        id="exampleFormControlInput1-1" placeholder=""
                                                        formControlName="willing_to_rent_to_single_women">
                                                    <label for="exampleFormControlInput1-2"
                                                        class="form-label m-1 ps-1">Single
                                                        Women</label>

                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-xl-6 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">
                                                Age of Property(yrs)
                                            </label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="1" formControlName="age">
                                        </div>

                                        <div class="col-xl-6 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">
                                                Year Built
                                            </label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="1" formControlName="year_built">
                                        </div>

                                        <div class="col-xl-6 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">
                                                Keys Quantity
                                            </label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="1" formControlName="keys_quantity">
                                        </div>

                                        <div class="col-xl-6 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">
                                                Eletrical Service Number
                                            </label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="1" formControlName="electrical_service_number">
                                        </div>

                                        <div class="col-xl-6 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">
                                                Furnished
                                            </label>
                                            <select class="form-select" formControlName="furnished_type">
                                                <option value="" selected disabled>Please select
                                                </option>
                                                <option value="Fully Furnished">Fully Furnished
                                                </option>
                                                <option value="Semi Furnished">Semi Furnished
                                                </option>
                                                <option value="UnFurnished">UnFurnished</option>
                                            </select>
                                        </div>

                                        <div class="col-xl-6 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">
                                                Total Bedrooms
                                            </label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="1" formControlName="total_bedrooms">
                                        </div>

                                        <div class="col-xl-6 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">
                                                Total Bathrooms
                                            </label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="1" formControlName="total_bathrooms">
                                        </div>

                                        <div class="col-xl-6 mb-3">
                                            <label for="exampleFormControlInput1-2" class="form-label">
                                                Total Balconies
                                            </label>
                                            <input type="text" class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="1" formControlName="total_balconies">
                                        </div>

                                        <div class="col-xl-6 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Project
                                                Description</label>
                                            <textarea class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="Description" formControlName="description"></textarea>
                                        </div>

                                        <div class="col-xl-6 mb-3">
                                            <label for="exampleFormControlInput1-1" class="form-label">Near by
                                                information</label>
                                            <textarea class="form-control" id="exampleFormControlInput1-1"
                                                placeholder="Near by" formControlName="near_by_info"></textarea>
                                        </div>

                                        <div class="col-xl-6 mb-3">
                                            <label class="form-label">Latitude</label>
                                            <input type="text" class="form-control"
                                                placeholder="e.g. 28.6139" formControlName="latitude">
                                        </div>

                                        <div class="col-xl-6 mb-3">
                                            <label class="form-label">Longitude</label>
                                            <input type="text" class="form-control"
                                                placeholder="e.g. 77.2090" formControlName="longitude">
                                        </div>

                                        <div class="col-xl-6 mb-3">
                                            <label class="form-label">Maps Link</label>
                                            <input type="text" class="form-control"
                                                placeholder="Google Maps URL" formControlName="maps_link">
                                        </div>

                                    </div>

                                    <div class="row">
                                        <div class="col-xl-12">
                                            <button class="btn btn-primary ms-1 me-3 float-end" type="submit"
                                                [disabled]="propertyDetailsForm.invalid || loadingService.isLoading()">Save
                                                Property</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="3">
                        <a ngbNavLink>Rooms</a>
                        <ng-template ngbNavContent>
                            <!-- <form [formGroup]="roomsForm" (ngSubmit)="saveRoomDetails()" autocomplete="off"> -->
                            <div class="p-2 mt-1 ms-2">
                                <div class="row mb-2">
                                    <div class="col-md-12">
                                        <!-- <button class="btn btn-danger btn-sm me-2 float-end" type="button" [disabled]="!deleteListImages.length">Delete</button> -->
                                        <button class="btn btn-primary btn-sm me-2 float-end" type="button"
                                            (click)="showHideRoom()">Add Room</button>
                                        <!-- <button class="btn btn-info btn-sm me-2 float-end" type="button" (click)="saveAllowedList()" [disabled]="!allowListingValues.length">Save</button> -->
                                    </div>
                                </div>
                                <form [formGroup]="editRoomItemsForm" (ngSubmit)="saveRoomItems()">
                                    <div ngbAccordion class="{{ maneClass }}"
                                        *ngFor="let room of editrooms.controls; let i = index" formArrayName="editrooms"
                                        id="room-{{ i }}">
                                        <div ngbAccordionItem #item="ngbAccordionItem" [collapsed]="true" class="item"
                                            [formGroupName]="i">
                                            <h2 ngbAccordionHeader
                                                [ngClass]="{'accordion-header accordion-header-primary': bg}">
                                                <button ngbAccordionButton class="accordion-header rounded-lg">
                                                    {{ room.get('room_name')?.value }}
                                                </button>
                                            </h2>
                                            <div ngbAccordionCollapse>
                                                <div ngbAccordionBody>
                                                    <ng-template>
                                                        <div class="row">
                                                            <div class="col-xl-12">
                                                                <button type="button"
                                                                    class="btn btn-danger shadow btn-xs sharp me-2 float-end"
                                                                    (click)="deletePropertyRoom(room.get('id')?.value)">
                                                                    <i class="fa fa-trash"></i>
                                                                </button>
                                                                <button type="button"
                                                                    class="btn btn-success shadow btn-xs sharp me-2 float-end"
                                                                    (click)="showHideEditRoom(room.get('id')?.value, room.get('room_name')?.value)">
                                                                    <i class="fa fa-edit"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-2 ms-2" formArrayName="items">
                                                            <div class="col-md-3 mb-3"
                                                                *ngFor="let item of getItems(i).controls; let j = index"
                                                                [formGroupName]="j">

                                                                <div class="row align-items-center">
                                                                    <!-- Label -->
                                                                    <div class="col-6">
                                                                        <label class="form-label mb-0">
                                                                            {{ item.get('item_name')?.value }}:
                                                                        </label>
                                                                    </div>

                                                                    <!-- Input -->
                                                                    <div class="col-6">
                                                                        <input type="number" class="form-control"
                                                                            placeholder="Quantity" autocomplete="off"
                                                                            formControlName="value" min="0" max="99"
                                                                            (blur)="onInputBlur(room.get('id')?.value, item.get('id')?.value, item.get('value')?.value)"
                                                                            (keypress)="allowOnlyNumbers($event)">
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>


                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <!-- <div class="row">
                                        <div class="col-xl-12">
                                            <button class="btn btn-primary ms-1 me-3 float-end" type="submit" [disabled]="roomsForm.invalid || loadingService.isLoading()">Save Room Details</button>
                                        </div>
                                    </div> -->
                            </div>
                            <!-- </form> -->
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="4">
                        <a ngbNavLink>Property Amenities</a>
                        <ng-template ngbNavContent>
                            <form [formGroup]="propertyAminitiesForm" (ngSubmit)="saveAminities()" autocomplete="off">
                                <div class="p-3 mt-2 ms-3">
                                    <div class="row" formArrayName="propertyAminities">
                                        <div class="col-xl-4"
                                            *ngFor="let aminity of propertyAminitiesList; let i= index">
                                            <div class="form-check custom-checkbox mb-2">
                                                <input type="checkbox" class="form-check-input" [id]="aminity.id"
                                                    [formControlName]="i">
                                                <label class="form-check-label"
                                                    [for]="aminity.id">{{aminity.propertyAmenitiesType}}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-12">
                                            <button class="btn btn-primary ms-1 me-3 float-end" type="submit"
                                                [disabled]="!getSelectedAminities.length || loadingService.isLoading()">Save
                                                Property Aminities</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="5">
                        <a ngbNavLink>Images</a>
                        <ng-template ngbNavContent>
                            <div class="p-3 mt-2 ms-2">

                                <div class="row mb-2">
                                    <div class="col-md-12">
                                        <!-- <button class="btn btn-danger btn-sm me-2 float-end" type="button" [disabled]="!deleteListImages.length">Delete</button> -->
                                        <button *ngIf="checkAddImages" class="btn btn-primary btn-sm me-2 float-end"
                                            type="button" (click)="openCenter(content)">Upload Images</button>
                                        <!-- <button class="btn btn-info btn-sm me-2 float-end" type="button" (click)="saveAllowedList()" [disabled]="!allowListingValues.length">Save</button> -->
                                    </div>
                                </div>
                                <div class="container-fluid">
                                    <div class="container mt-0">
                                        <div class="row">
                                            <div class="col-sm-4" *ngFor="let image of propertyImages">
                                                <div class="box">
                                                    <div class="imgbox c-pointer"
                                                        (click)="viewPropertyImage(viewImagecontent)">
                                                        <img [src]="image.image_link" class="img-display">
                                                    </div>
                                                    <div class="content w-100 text-center">
                                                        <span class="ms-0 fs-4" *ngIf="checkUpdateImageListing">
                                                            <i class="fa fa-eye icons-color c-pointer"
                                                                *ngIf="!image.allow_listing"
                                                                (click)="saveAllowedList(image.uid, true)"></i>
                                                            <i class="fa fa-eye-slash icons-color c-pointer"
                                                                *ngIf="image.allow_listing"
                                                                (click)="saveAllowedList(image.uid, false)"></i>
                                                            <!-- <input type="checkbox" class="form-check-input mt-1" id="exampleFormControlInput1-1" placeholder="" [checked]="image.allow_listing" (change)="allowListing(image.uid, $event)">  -->
                                                        </span>
                                                        <span class="ms-4 fs-4" *ngIf="checkDeleteImages">
                                                            <i class="fa fa-trash icons-color c-pointer"
                                                                (click)="deletePropertyImage(image.uid)"></i>
                                                        </span>
                                                        <!-- <a href="javascript void(0)" class="btn btn-default btnD">Read More</a> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="6">
                        <a ngbNavLink>Platform</a>
                        <ng-template ngbNavContent>
                            <div class="p-3">
                                <div class="basic-list-group notifications-list" *ngIf="selectedProperty.platforms">
                                    <div class="table-responsive">
                                        <form [formGroup]="platformForm" (ngSubmit)="savePlatforms()"
                                            autocomplete="off">
                                            <table class="table mb-2" formArrayName="platforms">
                                                <thead>
                                                    <tr>
                                                        <th>Platform</th>
                                                        <th class="text-center w-25">Platform ID</th>
                                                        <th class="text-center">PlatformLink</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let group of platformsArray.controls; let i = index"
                                                        [formGroupName]="i">
                                                        <td>
                                                            <h6 class="mb-0">{{ group.get('platform_name')?.value }}
                                                            </h6>
                                                        </td>
                                                        <td class="w-25">
                                                            <div
                                                                class="form-check custom-checkbox mb-3 checkbox-warning ms-2">
                                                                <input type="text"
                                                                    formControlName="property_platform_id"
                                                                    class="form-control" placeholder="Platform Id" [readonly]="group.get('platform_name')?.value === 'Direct'"/>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div
                                                                class="form-check custom-checkbox mb-3 checkbox-primary ms-2">
                                                                <input type="text"
                                                                    formControlName="property_platform_link"
                                                                    class="form-control" placeholder="Platform Link" [readonly]="group.get('platform_name')?.value === 'Direct'"/>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div class="row w-100">
                                                <div class="col-xl-12">
                                                    <button class="btn btn-primary ms-1 me-3 float-end" type="submit"
                                                        [disabled]="loadingService.isLoading()">Save</button>
                                                </div>
                                            </div>
                                        </form>

                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </li>
                </ul>
                <div [ngbNavOutlet]="nav" class="mt-2"></div>
            </div>



        </div>

    </div>
</div>

<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Upload Images</h5>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
    </div>
    <form *ngIf="propertyForm" [formGroup]="uploadImagesForm" (ngSubmit)="saveImages()" autocomplete="off">
        <div class="modal-body">
            <div class="row">
                <div class="col-xl-12 mb-3">
                    <label for="exampleFormControlInput1-1" class="form-label">Upload Upto 10 Images<span
                            class="text-danger">*</span></label>
                    <input name="file" type="file" accept="image/*" class="form-control" multiple
                        (change)="uploadImages($event)">
                    <div *ngIf="uploadImagesForm?.get('property_images')?.invalid && uploadImagesForm?.get('property_images')?.touched"
                        class="required">
                        Please select atleast one image
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
            <button type="submit" class="btn btn-primary "
                [disabled]="uploadImagesForm.invalid || loadingService.isLoading()">Upload</button>
        </div>
    </form>
</ng-template>

<ng-template #viewImagecontent let-modal>
    <div class="modal-header">
        <h5 class="modal-title"> Property Images </h5>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
        <ngb-carousel class="fixed-height-carousel">

            <ng-template ngbSlide *ngFor="let image of propertyImages">
                <div class="picsum-img-wrapper">
                    <img [src]="image.image_link" alt="" class="d-block w-100" />
                </div>
            </ng-template>

        </ngb-carousel>
    </div>
    <div class="modal-footer">
        <!-- <button type="button" class="btn btn-secondary" (click)="prevImage(selectedImage.index)" [disabled]="selectedImage.prevImageDisable">Prev</button> -->
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
    </div>
</ng-template>

<div #add_room_popup class="offcanvas offcanvas-end customeoff {{ add_room ? 'show':''}}" tabindex="-1" id="add_room"
    data-bs-backdrop="static">
    <div class="offcanvas-header">
        <h5 class="modal-title" id="#gridSystemModal">Add Room</h5>
        <button type="button" class="btn-close" (click)="addRoomClose()">
            <i class="fa-solid fa-xmark"></i>
        </button>
    </div>
    <div class="offcanvas-body" *ngIf="roomsForm">
        <div class="container-fluid">
            <form [formGroup]="roomsForm" (ngSubmit)="saveRoom()" autocomplete="off">

                <div class="row">
                    <div class="col-xl-12 mb-3">
                        <label for="exampleFormControlInput1-1" class="form-label">Room Name<span
                                class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="Room name"
                            formControlName="room_name">
                        <div *ngIf="roomsForm?.get('room_name')?.invalid && roomsForm?.get('room_name')?.touched"
                            class="required">
                            Room Name is required
                        </div>
                    </div>
                    <div class="col-xl-12 mb-3">
                        <label class="form-label">Search Room Items</label>
                        <input type="text" class="form-control" placeholder="Search for room items"
                            formControlName="searchText" (input)="filterItems()" autocomplete="off">
                    </div>
                    <div class="col-xl-12 mb-3">
                        <label class="form-label mb-3">Select Room Items</label>
                        <div class="row" formArrayName="selectedItems">
                            <div class="col-12 col-sm-6 col-md-4 col-lg-3"
                                *ngFor="let permission of filteredItems; let i= index">
                                <div class="form-check custom-checkbox mb-2">
                                    <input type="checkbox" class="form-check-input" [id]="permission.id"
                                        [formControlName]="i">
                                    <label class="form-check-label" [for]="permission.id">{{permission.name}}</label>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="roomsForm?.get('selectedItems')?.invalid && roomsForm?.get('selectedItems')?.touched"
                            class="required">
                            At least one checkbox must be selected.
                        </div>
                    </div>

                </div>

                <div>
                    <button class="btn btn-primary ms-1 me-3" type="submit"
                        [disabled]="roomsForm.invalid || loadingService.isLoading()">Submit</button>
                    <button class="btn btn-danger lightme-1" type="button" (click)="addRoomClose()">Cancel</button>
                </div>
            </form>
        </div>
    </div>
</div>
@if(add_room){
<div class="offcanvas-backdrop fade show" (click)="showHideRoom()"></div>
}
